export default "__VITE_ASSET__WnozORzk__"